<template>
  <div v-if="$store.state.productsLoaded && $store.state.shelvesLoaded" id="home">
    <Header />
    <div class="content">
      <div class="content__inner">
        <ul class="nav flex-column">
          <li class="nav-item">
            <router-link class="nav-link" to="/query">Scan</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/arrival">Wareneingang</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/pick">Auftrag picken</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/purchase">Einkauf</router-link>
          </li>
        </ul>
      </div>
      <div style="text-align: center;">
        <button class="btn btn-small btn-light" @click="refreshApp">&#x21bb; Update</button>
        <small style="display: block; margin: 1rem 0 0;">v 0.3.4 ({{ env }})</small>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'
import { env } from '@/shared/firebase'
import { EventBus } from '@/EventBus'

export default {
  components: { Header },
  data() {
    return {
      env
    }
  },
  created() {
    EventBus.$on('scan', scan => {
      console.log(scan)
    })
  },
  beforeDestroy() {
    EventBus.$off('scan')
  },
  methods: {
    refreshApp: function() {
      window.location.reload(true)
    }
  }
}
</script>

<style lang="scss" scoped>
#home {
  background: #fff;
  height: 100%;
}

.nav-item {
  margin: 0 0 1rem;
  padding: 0.5rem;

  border: 1px #ccc solid;
  border-radius: 5px;
}
</style>
